/* Recording links in chat, and why they no longer navigate anywhere.
 *
 * A call recording's download URL used to be posted into DM and in-call
 * chat as a plain link. GET /api/calling/recordings/{id}/download is
 * authenticated now — it serves the audio and video of a private call,
 * and before batch 10 it had no authentication of any kind — and a
 * browser sends no Authorization header when you click a link. So every
 * one of those links already sitting in somebody's chat history is a
 * 401.
 *
 * The repair NOT taken: put a token in the URL. That turns a dead link
 * into a working credential written permanently into chat history, where
 * it outlives the conversation, survives export, and travels with every
 * copy-paste. A dead link is better than that.
 *
 * So the link is replaced rather than repaired. GET /api/calling/recordings
 * is already authenticated and already filtered to the people who were on
 * the call, and it mints a short-lived presigned URL per view — that is
 * the Recordings panel, and these links now open it.
 *
 * Chat history is rewritten at RENDER time, not in the database: messages
 * are a record of what was said.
 */

/* Matches the backend download route in any spelling that reaches chat:
 * absolute (what the backend DM used to write, and what VideoCallModal
 * used to post) or root-relative. */
export const RECORDING_URL_RE = /\/api\/calling\/recordings\/[^/\s]+\/download/;

export const OPEN_RECORDINGS_EVENT = "kwery:open-recordings";

export function isRecordingLink(url) {
  return RECORDING_URL_RE.test(String(url || ""));
}

export function openRecordingsPanel(e) {
  if (e) { e.preventDefault(); e.stopPropagation(); }
  window.dispatchEvent(new CustomEvent(OPEN_RECORDINGS_EVENT));
}
